
import { supabase } from '../../supabase';
import { ExitPageStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get top exit pages
 */
export const getExitPages = async (
  startDate: Date,
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<ExitPageStat[]> => {
  const { data, error } = await supabase.rpc('get_exit_pages', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });

  if (error) {
    console.error('Error fetching exit pages:', error);
    throw error;
  }

  return (data || []).map(item => ({
    page_path: item.page_path,
    count: Number(item.exit_count)
  }));
};
